export const PageDataState = {
    Searchs: {
        course_eb_03_id: {
            type: 'text',
            id: 'course_eb_03_id',
            label: '',
            value: ''
        },
        model_no: {
            type: 'text',
            id: 'model_no',
            label: 'รุ่นที่',
            value: '',
            placeholder: 'รุ่นที่'
        }
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false
            },
            error: { status: null, msg: '' }
        },
        course_eb_03_id: {
            type: 'select',
            id: 'course_eb_03_id',
            label: 'หลักสูตร',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },        
        model_no: {
            type: 'text',
            id: 'model_no',
            label: 'รุ่นที่',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 3
            },
            error: { status: null, msg: '' }
        },
        person_count: {
            type: 'text',
            id: 'person_count',
            label: 'จำนวน',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 500
            },
            error: { status: null, msg: '' }
        },
        duration_days: {
            type: 'text',
            id: 'duration_days',
            label: 'วัน',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 31
            },
            error: { status: null, msg: '' }
        },  
        training_hours: {
            type: 'text',
            id: 'training_hours',
            label: 'ชั่วโมง',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 24
            },
            error: { status: null, msg: '' }
        },  
        training_start_date: {
            type: 'text',
            id: 'training_start_date',
            label: 'วันที่เริ่มต้น',
            value: '',
            validator: {
                type: 'date',
                required: true
            },
            error: { status: null, msg: '' }
        }, 
        training_end_date: {
            type: 'text',
            id: 'training_end_date',
            label: 'วันที่สิ้นสุด',
            value: '',
            validator: {
                type: 'date',
                required: true
            },
            error: { status: null, msg: '' }
        },   
        budget: {
            type: 'text',
            id: 'budget',
            label: 'งบประมาณ',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 100000
            },
            error: { status: null, msg: '' }
        },                               
        seq: {
            type: 'text',
            id: 'seq',
            label: 'ลำดับ',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 250
            },
            error: { status: null, msg: '' }
        },
        training_status: {
            type: 'select',
            id: 'training_status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },               
    },
    InputGroup: {}
}